import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { requireAuth } from '@xemplo/auth-provider';
import { ErrorBoundary } from '@xemplo/error-boundary';
import { PayrollRoutes } from '@xemplo/gp-routes';
import { withLazyComponent } from '@xemplo/lazy-component';
import { Payrun, XemploPayPayrun } from '@xemplo/payrun';

const PayrunList = lazy(() =>
  import('@xemplo/payrun-list').then((m) => ({ default: m.PayrunList })),
);
const PayrunWorkers = lazy(() =>
  import('@xemplo/payrun-workers').then((m) => ({ default: m.PayrunWorkers })),
);
const PayrunAmendments = lazy(() =>
  import('@xemplo/payrun-amendments').then((m) => ({ default: m.PayrunAmendments })),
);
const PayrunChangelog = lazy(() =>
  import('@xemplo/payrun-changelog').then((m) => ({ default: m.PayrunChangelog })),
);

export const PayrunRoutesFullScreen: RouteObject[] = [
  {
    path: PayrollRoutes.PayrunById,
    Component: requireAuth(Payrun),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '',
        Component: requireAuth(withLazyComponent(PayrunWorkers, true)),
        children: [
          {
            path: PayrollRoutes.WorkerVarianceByWorkerId,
            Component: null,
          },
          {
            path: PayrollRoutes.WorkerDetailsByWorkerId,
            Component: null,
          },
          {
            Component: null,
            path: PayrollRoutes.WorkerAmendmentByAmendmentId,
          },
        ],
      },
      {
        path: PayrollRoutes.PayrunAmendments,
        Component: requireAuth(withLazyComponent(PayrunAmendments)),
      },
      {
        path: PayrollRoutes.Changelog,
        Component: requireAuth(withLazyComponent(PayrunChangelog)),
      },
    ],
  },
  {
    path: PayrollRoutes.PayrunXemploPayById,
    Component: requireAuth(XemploPayPayrun),
    errorElement: <ErrorBoundary />,
  },
];

export const PayrunRouteWithTemplate: RouteObject[] = [
  {
    path: PayrollRoutes.Payrun,
    Component: requireAuth(withLazyComponent(PayrunList)),
    errorElement: <ErrorBoundary />,
  },
];
